import styled from 'styled-components';

import { BaseStyle, ReactTableStyles } from '@nhl/nhl-breakaway-ui';
import { TeamDisplay } from '@nhl/nhl-react-ui/lib/TeamDisplay';

import { featuredTeamAbbrev } from '../../utils';

export const ClinchIndicator = styled.div<{ $isEliminated?: boolean }>`
    ${BaseStyle.Mixins.fontStyles.ui['12b']}
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
    width: 18px;
    height: 18px;
    border-radius: 4px;
    color: ${({ theme, $isEliminated }) => ($isEliminated ? theme.Text.secondary : theme.Text.primary)};
    background: ${({ theme, $isEliminated }) => ($isEliminated ? theme.Surface.primary : theme.Surface.tertiary)};
    border: ${({ theme, $isEliminated }) => ($isEliminated ? `1px solid ${theme.Text.secondary}` : 'none')};
    margin-left: 4px;
    text-transform: uppercase;
`;

export const TeamAndClinchContainer = styled.div<{ $isSmall: boolean }>`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: ${({ $isSmall }) => ($isSmall ? 'space-between' : 'auto')};

    a {
        width: fit-content;
    }
`;

export const StyledTeamDisplay = styled(TeamDisplay)`
    &.team-display-container {
        .team-display {
            display: flex;
            flex-direction: row;
        }
        .team-name {
            ${BaseStyle.Mixins.fontStyles.ui['14b']}
            text-align: left;
        }
    }

    & .team-display-standings {
        width: 100px;
    }
`;

export const StandingsTableContainer = styled.div`
    margin: 8px 0 16px 0;
    user-select: none;

    ${ReactTableStyles.CommonTableStyling};

    .rt-table-container {
        ${ReactTableStyles.TableScrollShadows};
    }

    .rt-table {
        .featured-club-standings-row {
            border: ${({ theme }) =>
                '1px solid ' + (theme.Team?.[featuredTeamAbbrev()]?.primary || theme.Surface.border)};
        }

        .wildcard-standings-cutoff-row {
            border-bottom: ${({ theme }) => '2px solid ' + theme.Surface.Opposite.primary};
        }
    }
`;

export const CenteredTableHeader = styled.div`
    text-align: center;
`;
